// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EUMz","question":"styles_question__1RSDq","inputVisibleButton":"styles_inputVisibleButton__2NQzA","note":"styles_note__1h4sI"};